import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isNumber from 'lodash/isNumber';
import { ApexTable } from 'apex-table-ts';
import LongDetailsPanel from '../LongDetailsPanel';
import messages from './messages';
import { loadState, saveState } from '../../utils';
import { LOCAL_STORAGE_COLUMNS_KEY, AUDIT_TRAIL_COLUMNS, MAX_COLUMN_WIDTH, MIN_COLUMN_WIDTH } from './constants';

class AuditTrailPanel extends Component {

  static propTypes = {
    auditTrailData: PropTypes.arrayOf(PropTypes.object).isRequired,
    intl: PropTypes.object.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    height: -1,
    width: -1,
  };

  static isValidColumnWidth(width) {
    return isNumber(width) && width >= MIN_COLUMN_WIDTH && width <= MAX_COLUMN_WIDTH;
  }

  static loadColumns(formatter) {
    const state = loadState(LOCAL_STORAGE_COLUMNS_KEY) || {};
    const columns = { ...AUDIT_TRAIL_COLUMNS };

    Object.keys(columns).forEach((key) => {
      if (key in messages) {
        columns[key].label = formatter(messages[key]);
      }

      const col = state[key] || {};
      if ('width' in col && AuditTrailPanel.isValidColumnWidth(col.width)) {
        columns[key].width = col.width;
      }
    });

    return columns;
  }

  static saveColumns(columns) {
    const state = {};

    Object.keys(columns).forEach((key) => {
      const col = columns[key] || {};
      if ('width' in col && AuditTrailPanel.isValidColumnWidth(col.width)) {
        state[key] = { width: col.width };
      }
    });

    saveState(LOCAL_STORAGE_COLUMNS_KEY, state);
  }

  constructor(props) {
    super(props);
    this.state = {
      columns: AuditTrailPanel.loadColumns(this.props.intl.formatMessage),
    };
    this.handleColumnResize = this.handleColumnResize.bind(this);
  }

  handleColumnResize(key, width) {
    const { columns } = this.state;
    columns[key].width = width;
    AuditTrailPanel.saveColumns(columns);
    this.setState({ columns });
  }

  render() {
    const {
      auditTrailData,
      height,
      width,
    } = this.props;
    return (
      <LongDetailsPanel title={<FormattedMessage {...messages.auditTrail} />}>
        <div className="audit-trail-panel">
          <ApexTable
            columns={this.state.columns}
            defaultSortColumn="timeStamp"
            isLoading={false}
            enableColumnResize
            enableColumnSort
            maxColumnWidth={MAX_COLUMN_WIDTH}
            minColumnWidth={MIN_COLUMN_WIDTH}
            onColumnResized={this.handleColumnResize}
            rows={auditTrailData}
            height={height}
            width={width}
          />
        </div>
      </LongDetailsPanel>
    );
  }

}

export default AuditTrailPanel;



// WEBPACK FOOTER //
// ./src/components/AuditTrailPanel/index.js